const chevron = () => (
  <>
    <path
      d="M14.7505 11.6372C14.7505 11.7449 14.733 11.8442 14.6978 11.9352C14.6625 12.0262 14.6012 12.1154 14.514 12.2027L10.1255 16.591C10.032 16.6846 9.91729 16.7346 9.78129 16.741C9.64545 16.7475 9.52437 16.6975 9.41803 16.591C9.31153 16.4846 9.25829 16.3667 9.25829 16.2372C9.25829 16.1077 9.31153 15.9898 9.41803 15.8835L13.664 11.6372L9.41803 7.39095C9.32437 7.29745 9.27437 7.1827 9.26803 7.0467C9.26153 6.91087 9.31153 6.78979 9.41803 6.68345C9.52437 6.57695 9.64228 6.52371 9.77178 6.52371C9.90128 6.52371 10.0192 6.57695 10.1255 6.68345L14.514 11.0717C14.6012 11.159 14.6625 11.2482 14.6978 11.3392C14.733 11.4302 14.7505 11.5295 14.7505 11.6372Z"
      fillOpacity={0.6}
    />
  </>
)
export default chevron
